// Inline error banner — mapped API error codes only, never a raw server
// string (root CLAUDE.md). Used both as a small inline banner beneath a
// specific form/action (the common case in this app — an OTP request, a
// verify attempt, a final submit) and, via the `fullPage` prop, as a
// full-page error (e.g. a genuinely wrong-app session state).
//
// When the caller passes the `error` it caught (an ApiError from
// shared/api/client.js, or a TanStack Query `query.error`), the code the
// API returned is shown beneath the message so a customer reporting a
// problem can name what failed. The full response is logged to the console
// in development by the api client itself.

import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './ErrorState.module.css';

export default function ErrorState({
  messageId = 'error.INTERNAL_ERROR',
  error,
  fullPage = false,
}) {
  const { t } = useLanguage();
  // `error` is the ApiError the caller caught (or a TanStack Query
  // `query.error`, which is that same ApiError). We surface only its `code`
  // — never `error.body` or `error.message`, which can carry a raw server
  // string (root CLAUDE.md).
  const code = error && error.code ? error.code : null;

  return (
    <div className={fullPage ? styles.fullPage : styles.banner} role="alert">
      <p className={styles.message}>{t(messageId)}</p>
      {code && (
        <p className={styles.code}>
          {t('error.codeLabel')}: <span>{code}</span>
        </p>
      )}
    </div>
  );
}
